// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from "firebase/auth";
import { getFirestore, doc, setDoc, serverTimestamp, collection } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDhvHyYgATzjjLgSv8zB6IGWi3LUJ068-o",
  authDomain: "bd-andivi.firebaseapp.com",
  databaseURL: "https://bd-andivi-default-rtdb.firebaseio.com",
  projectId: "bd-andivi",
  storageBucket: "bd-andivi.firebasestorage.app",
  messagingSenderId: "215591673885",
  appId: "1:215591673885:web:f51f919b69e3a5606ae6f4",
  measurementId: "G-8HKBWKSJBE"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const database = getDatabase(app);
const analytics = getAnalytics(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup, signOut, db, storage, doc, setDoc, serverTimestamp, analytics, collection, database, firebaseConfig };
